module.exports = ".align-buttons {\n  text-align: right;\n  padding-bottom: 50px; }\n\ntd {\n  border: 1px solid;\n  max-width: 100px; }\n\n.pdf-container {\n  width: 100%; }\n\n.higher {\n  background: #D6D6D6; }\n\n.table {\n  margin: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-view-pdf-technician/master-view-pdf-technician.component.scss
// module id = ./src/app/master/master-view-pdf-technician/master-view-pdf-technician.component.scss
// module chunks = main